import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import * as _ from "lodash";
import { Observable } from "rxjs/Observable";

import { TAAConstants } from "../../constants/taa-constants";
import { AccommsService } from "../../services/accomms.service";
import { AppService } from "../../services/app.service";
import { LoggerService } from "../../services/audit-logger.service";
import { CommonService } from "../../services/common.service";
import { PersonService } from "../../services/person.service";
import { ReasonService } from "../../services/reason.service";
import { RequestSubmitService } from "../../services/requestsubmit.service";
import { User } from "../../services/user.model";
import { StepperComponent } from "../stepper/stepper.component";

@Component({
  selector: "app-reason",
  templateUrl: "./reason.component.html",
  styleUrls: ["./reason.component.css"]
})
export class ReasonComponent implements OnInit {
  public taaPin: string;
  public frmReason: FormGroup;
  public disabilities: any[];
  public langDisabilities: any[];
  public personName: string;
  public validationErrors: any;
  public personDisabilities: any;
  public reconsideration: string;
  public userProfile: User;
  public auditStatusText: string = "";
  public auditLogCategory: string = "";
  public statusCd: string;
  public currentRecord: any;
  public requestId: any;
  public isSaved: boolean = false;
  public clickedOnce: boolean;
  public clickedSaveAndContinue: boolean;
  public prevSavedFrmReason: any = {
    disabilityStatus: false,
    englishLearner: false
  };
  formSubmitted = false;
  recordCount = "0";
  @ViewChild('openModal') openModal: ElementRef;

  // tslint:disable-next-line:no-input-rename
  @Input("request") request;
  savedRequest: Request;
  frmReasonError: any = { showit: false, errorCount: 0 };
  @ViewChild("noReasonModalTrigger") noReasonModalTrigger: ElementRef;

  constructor(
    private fb: FormBuilder,
    public stepper: StepperComponent,
    private router: Router,
    private reasonService: ReasonService,
    private personService: PersonService,
    public commonService: CommonService,
    public taaConstants: TAAConstants,
    public requestSubmitService: RequestSubmitService,
    private appService: AppService,
    private _loggerService: LoggerService,
    private accommsService: AccommsService
  ) {
    this.frmReason = this.fb.group({
      disabilityStatus: [],
      disabilityCategories: this.fb.array([]),
      langDisability: this.fb.group({
        selected: [],
        otherDesc: []
      }),
      englishLearner: [],
      otherDisablityDesc: []
    });
  }

  validate = () => {
    if (!this.frmReason) {
      return;
    }

    const formData = this.frmReason.value;

    if (
      _.isEmpty(formData.disabilityStatus) ||
      _.isEmpty(formData.englishLearner)
    ) {
      this.noReasonModalTrigger.nativeElement.click();
      return { requiredReason: false, errorCount: 0, case: "1a" };
    }

    if (
      _.isEmpty(formData.disabilityStatus) &&
      formData.englishLearner === "no"
    ) {
      this.noReasonModalTrigger.nativeElement.click();
      return { requiredReason: false, errorCount: 0, case: "1b" };
    }

    if (
      formData.disabilityStatus === "no" &&
      _.isEmpty(formData.englishLearner)
    ) {
      this.noReasonModalTrigger.nativeElement.click();
      return { requiredReason: false, errorCount: 0, case: "1c" };
    }

    if (
      formData.disabilityStatus === "no" &&
      formData.englishLearner === "no"
    ) {
      this.noReasonModalTrigger.nativeElement.click();
      return { requiredReason: false, errorCount: 0, case: 2 };
    }

    const selectedDisabilities = [];
    let otherDisablityDescError = false;

    formData.disabilityCategories.forEach(category => {
      category.disabilities.forEach(disability => {
        if (
          disability.DISABILITY_DS === "OTHER" &&
          formData.otherDisablityDesc !== null
        ) {
          if (
            formData.otherDisablityDesc !== "" ||
            formData.otherDisablityDesc.trim() !== ""
          ) {
            otherDisablityDescError = !this.regexTest(
              formData.otherDisablityDesc,
              500
            );
            disability.otherDesc = formData.otherDisablityDesc;
            disability.checked = true;
          }
        }

        if (disability.DISABILITY_DS === "OTHER") {
          if (
            formData.otherDisablityDesc === null ||
            formData.otherDisablityDesc.trim() === ""
          ) {
            otherDisablityDescError = false;
            disability.checked = false;
          }
        }

        if (disability.checked) {
          selectedDisabilities.push(disability);
        }
      });
    });

    let otherLangDisabilityError = false;
    if (formData.langDisability.selected.DISABILITY_NM === "ELL_VERBAL_INST") {
      otherLangDisabilityError = !this.regexTest(
        formData.langDisability.otherDesc,
        32
      );
    }

    const validator = {
      hasDisabilityStatusSelected: formData.disabilityStatus === "yes",
      hasDisabilityValuesSelected: !!selectedDisabilities.length,
      hasEnglishLearnerSelected: formData.englishLearner === "yes",
      hasLangDisabilitySelected: !_.isEmpty(formData.langDisability.selected)
    };

    if (
      validator.hasDisabilityStatusSelected &&
      !validator.hasDisabilityValuesSelected &&
      validator.hasEnglishLearnerSelected &&
      !validator.hasLangDisabilitySelected
    ) {
      return {
        requiredDisability: true,
        requiredLangDisability: true,
        errorCount: 2,
        case: 3
      };
    }

    if (
      validator.hasDisabilityStatusSelected &&
      !validator.hasDisabilityValuesSelected
    ) {
      return { requiredDisability: true, errorCount: 1, case: 4 };
    }

    if (
      validator.hasEnglishLearnerSelected &&
      !validator.hasLangDisabilitySelected
    ) {
      return { requiredLangDisability: true, errorCount: 1, case: 5 };
    }

    if (otherDisablityDescError && otherLangDisabilityError) {
      return {
        requiredDisability: true,
        requiredLangDisability: true,
        otherDisablityDescError: true,
        otherLangDisabilityError: true,
        errorCount: 2,
        case: 6
      };
    }

    if (otherDisablityDescError) {
      return {
        requiredDisability: true,
        otherDisablityDescError: true,
        errorCount: 1,
        case: 7
      };
    }

    if (otherLangDisabilityError) {
      return {
        requiredLangDisability: true,
        otherLangDisabilityError: true,
        errorCount: 1,
        case: 8
      };
    }

    return null;
  }

  regexTest(str, length) {
    if (_.isEmpty(_.toString(str))) {
      return false;
    }
    if (str.length > length) {
      return false;
    }
    const pattern = /^[a-zA-Z0-9\.\s\,\'\:\;]{1,500}$/;
    const regex = new RegExp(pattern);
    return regex.test(str);
  }

  saveReasonData(proceed: boolean): void {
    this.clickedOnce = true;
    this.reasonService
      .delPersonDisabilityIdsByPersonId(this.stepper.request.personId)
      .subscribe(result => {
        this.validationErrors = this.validate();
        this.frmReasonError = {
          showit: false,
          requiredLangDisability: "",
          requiredDisability: "",
          errorCount: 0
        };

        if (this.validationErrors) {
          const showit =
            this.validationErrors.requiredDisability ||
            this.validationErrors.requiredLangDisability ||
            false;
          this.frmReasonError = {
            showit: showit,
            requiredDisability:
              this.validationErrors.requiredDisability || false,
            requiredLangDisability:
              this.validationErrors.requiredLangDisability || false,
            otherDisablityDescError:
              this.validationErrors.otherDisablityDescError || false,
            otherLangDisabilityError:
              this.validationErrors.otherLangDisabilityError || false,
            errorCount: this.validationErrors.errorCount
          };
          return;
        }

        this.formSubmitted = true;
        const request: any = {
          requestId: this.stepper.request.requestId,
          personId: this.stepper.request.personId
        };
        const formData = this.frmReason.value;

        if (formData.disabilityStatus === "yes") {
          request.selectedDisabilities = [];
          formData.disabilityCategories.forEach(category => {
            category.disabilities.forEach(disability => {
              if (disability.DISABILITY_DS === "OTHER") {
                disability.otherDesc = formData.otherDisablityDesc;
              }
              let prevSelectedAccom;
              if (this.recordCount !== "0") {
                prevSelectedAccom = (<any[]>this.personDisabilities).find(
                  val => val.DISABILITY_ID === disability.DISABILITY_ID && val.LOCKED_FL === '1'
                );
              }
              if (disability.checked && !prevSelectedAccom) {
                request.selectedDisabilities.push(disability);
              }
            });
          });
        }
        request.disabilityStatus = formData.disabilityStatus;
        request.englishLearner = formData.englishLearner;
        if (formData.englishLearner === "yes") {
          let prevSelectedLang;
          if (this.recordCount !== "0") {
            prevSelectedLang = (<any[]>this.personDisabilities).find(
              val => val.DISABILITY_ID === formData.langDisability.selected.DISABILITY_ID && val.LOCKED_FL === '1'
            );
          }
          if (!prevSelectedLang) {
            request.langDisability = formData.langDisability;
          }else {
            formData.langDisability.selected = [];
            request.langDisability = formData.langDisability;
          }
        }
        this.removeDisabilityId(request, proceed);
      });
  }

  removeDisabilityId(request: any, proceed: any) {
    if (_.isEmpty(this.personDisabilities)) {
      this.saveDisabilityId(request, proceed, false);
      return;
    }
    const responseOnDeletingRow = [];
    _.each(this.personDisabilities, row => {
      this.reasonService
        .removeDisabilityById(row.PERSON_DISABILITY_ID)
        .subscribe(response => {
          responseOnDeletingRow.push(response || "dummy text");
          if (responseOnDeletingRow.length === this.personDisabilities.length) {
            this.isSaved = false;
            this.saveDisabilityId(request, proceed, this.isSaved);
          }
        });
      this.isSaved = true;
    });
  }

  saveDisabilityId(request, proceed, isSaved) {
    if (!isSaved) {
      this.reasonService.saveReasonRequest(request).subscribe((data: any) => {
        if (this.recordCount !== "0") {
          Observable.forkJoin(
            this.requestSubmitService.getRequestStatusCodeIdByNm(
              this.taaConstants.getRECONSIDER_INCOMPLETE()
            )
          ).subscribe(([submitStatus]) => {
            const updateRequest = {
              PERSON_ID: this.stepper.request.personId,
              REQUEST_ID: this.stepper.request.requestId,
              REQUEST_STATUS_CODE_ID: submitStatus[0].REQUEST_STATUS_CODE_ID
            };
            Observable.forkJoin(
              this.commonService.updateRequestForReconsider(updateRequest)
            ).subscribe(
              success => {
                this.clickedOnce = false;
                if (proceed) {
                  this.auditStatusText =
                    "Request updated on Reason page Page from Complete to ReconsiderIncomplete ";
                  this.auditLogCategory = "STATUS_CHANGE";
                  this.updateLogs();
                  sessionStorage.setItem("reasonSubmitted", "true");
                  this.stepper.goToNextStep();
                }
                this.formSubmitted = false;
              },
              err => {
                this.clickedOnce = false;
              }
            );
          });
        } else {
          if (proceed) {
            if (
              this.statusCd === this.taaConstants.getRECONSIDER_INCOMPLETE()
            ) {
              this.auditStatusText = "Request updated on Reason Page ";
              this.auditLogCategory = "REQUEST_CHANGE";
              this.updateLogs();
            }
            sessionStorage.setItem("reasonSubmitted", "true");
            this.stepper.goToNextStep();
            this.clickedSaveAndContinue = true;
          }
          this.formSubmitted = false;
          this.clickedSaveAndContinue = false;
        }
      });
    } else {
      this.clickedOnce = false;
    }
  }

  getPreviousRecordDetails = () => {
    this.stepper.goToPrevStep();
  }

  ngOnInit() {
    this.clickedOnce = false;
    this.clickedSaveAndContinue = false;
    sessionStorage.setItem("testSubmitted", "");
    this.currentRecord = this.stepper.getPreviousRecordDetails();
    this.personName = this.stepper.request
      ? this.stepper.request.personName
      : "";
    this.taaPin = this.stepper.request ? this.stepper.request.taaPin : "";
    Observable.forkJoin(
      this.commonService.getDynContent(
        "REQUEST_STATUS_UPDATED_TO_RECONSIDER_MSG"
      )
    ).subscribe(([reconsideration]) => {
      this.reconsideration = reconsideration;
      this.appService.getUserProfile().then(user => (this.userProfile = user));
    });
    this.getPersonDisability();
    this.getStatusCode();
  }

  getStatusCode() {
    this.accommsService
      .getRequests(this.currentRecord.requestId)
      .subscribe((data: any) => {
        this.accommsService
          .getRequestedStatusCode(data[0].REQUEST_STATUS_CODE_ID)
          .subscribe((success: any) => {
            this.statusCd = success[0].STATUS_CD;
          });
      });
  }

  getPersonDisability() {
    Observable.forkJoin(
      this.commonService.getFinishedRecordCount(this.stepper.request.personId),
      this.personService.getPersonDisabilityById(this.stepper.request.personId)
    ).subscribe(([finishedRecordCount, response]) => {
      if (finishedRecordCount === "1") {
        this.recordCount = "1";
      } else if (finishedRecordCount === "error") {
        this.openModal.nativeElement.click();
      }
      // this.recordCount = finishedRecordCount as any;
      this.personDisabilities = response;
      this.getDisabilities();
    });
  }
  gotoHome() {
    setTimeout(() => {
      this.router.navigate(["/examinees"]);
    }, 500);
  }
  getDisabilities() {
    this.reasonService.getDisabilities().subscribe(response => {
      const dis: any[] = <Array<any>>response;
      this.disabilities = [];
      this.langDisabilities = [];
      for (let i = 0; i < dis.length; i++) {
        if (
          dis[i]["DISABILITY_CATEGORY_TYPE"] === "A" ||
          dis[i]["DISABILITY_CATEGORY_TYPE"] === null
        ) {
          this.disabilities.push(dis[i]);
        } else {
          this.langDisabilities.push(dis[i]);
        }
      }

      const catFGs = this.disabilities.map(category => {
        const disablilites = category["DISABILITY_DS"];
        const disabilitiesFGs = disablilites.map(disability => {
          disability.checked = this.hasPersonCheckedThisDisability(disability);
          return this.fb.group(disability);
        });
        return this.fb.group({
          disabilities: this.fb.array(disabilitiesFGs)
        });
      });
      this.frmReason.setControl("disabilityCategories", this.fb.array(catFGs));
      let selectedLangDisability = {};
      _.each(this.personDisabilities, disability => {
        const matchingLangDisability = _.find(
          this.langDisabilities[0].DISABILITY_DS,
          { DISABILITY_ID: disability.DISABILITY_ID }
        );
        if (!_.isEmpty(matchingLangDisability)) {
          selectedLangDisability = matchingLangDisability;
        }
      });
      this.prevSavedFrmReason.englishLearner = !_.isEmpty(
        selectedLangDisability
      );
      this.frmReason.setControl(
        "langDisability",
        this.fb.group({ selected: selectedLangDisability, otherDesc: "" })
      );
      if (this.prevSavedFrmReason.englishLearner) {
        this.frmReason.controls.englishLearner.setValue("yes");
      } else if (this.personDisabilities.length) {
        this.frmReason.controls.englishLearner.setValue("no");
      }
      if (this.prevSavedFrmReason.disabilityStatus) {
        this.frmReason.controls.disabilityStatus.setValue("yes");
      } else if (this.personDisabilities.length) {
        this.frmReason.controls.disabilityStatus.setValue("no");
      }
      if (this.personDisabilities.length) {
        const disabilitiesWithNm = _.map(response, disability => {
          return {
            DISABILITY_DS: disability.DISABILITY_DS,
            DISABILITY_NM: disability.DISABILITY_NM,
            DISABILITY_CATEGORY_TYPE: disability.DISABILITY_CATEGORY_TYPE
          };
        });
        let disabilityOtherDescWithNM = "";
        let languageOtherDescWithNm = {};
        let languageOtherDescWithNmSelected = {};
        _.each(this.personDisabilities, disability => {
          _.each(disabilitiesWithNm, dds => {
            const matchingDDNM = _.find(dds.DISABILITY_DS, {
              DISABILITY_ID: disability.DISABILITY_ID
            });
            if (!_.isEmpty(matchingDDNM)) {
              if (matchingDDNM.DISABILITY_NM === "O") {
                disabilityOtherDescWithNM = disability.OTHER_DS;
              }
              if (
                dds.DISABILITY_CATEGORY_TYPE === "E" ||
                matchingDDNM.DISABILITY_NM === "ELL_VERBAL_INST"
              ) {
                languageOtherDescWithNmSelected = matchingDDNM;
                languageOtherDescWithNm = disability.OTHER_DS;
              }
            }
          });
        });

        this.frmReason.controls.otherDisablityDesc.setValue(
          disabilityOtherDescWithNM
        );
        this.frmReason.setControl(
          "langDisability",
          this.fb.group({
            selected: languageOtherDescWithNmSelected,
            otherDesc:
              languageOtherDescWithNm &&
                Object.keys(languageOtherDescWithNm).length === 0 &&
                languageOtherDescWithNm.constructor === Object
                ? ""
                : languageOtherDescWithNm
          })
        );
      }
    });
  }

  hasPersonCheckedThisDisability(disability) {
    const hasChecked = _.filter(this.personDisabilities, {
      DISABILITY_ID: disability.DISABILITY_ID
    });
    this.prevSavedFrmReason.disabilityStatus =
      this.prevSavedFrmReason.disabilityStatus || !_.isEmpty(hasChecked);
    return !_.isEmpty(hasChecked);
  }

  resetError(errorType: string) {
    if (errorType === "disability") {
      this.frmReasonError.requiredDisability = false;
    }
    if (errorType === "language") {
      this.frmReasonError.requiredLangDisability = false;
    }
  }

  setInputToEmpty() {
    this.frmReason.controls.langDisability.patchValue({
      otherDesc: ""
    });
  }

  reset() {
    this.frmReason.value.langDisability.selected = {};
  }

  updateLogs() {
    const loggerModel = {
      MODULE_ID: "REQUEST",
      CATEGORY_ID: this.auditLogCategory,
      COMPONENT_ID: "REQUEST_DISABILITIES_PAGE",
      CREATED_BY_DS: this.userProfile.userName,
      MESSAGE_TX: this.auditStatusText,
      REFERENCE_ID: this.stepper.request.personId,
      SEVERITY_VAL: "",
      UPDATED_BY_DS: this.userProfile.userName,
      USER_DATA_VAL: this.userProfile.userName
    };
    this._loggerService.updateLog(loggerModel).subscribe(
      success => { },
      err => {
        console.log(err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./client/views/request/reason/reason.component.ts